<template>
  <div>
    <!-- <div>
        <h4 class="font-weight-bold mt-3" style="color:#48a6a6;     padding-left: 0px;">Organizations</h4>
    </div> -->

    <!-- setting here -->
    <div class="row m-0 p-0">
      <div class="col-md-4" style="padding-left:0px;     padding-top: 0px;">
      <!-- <a href="/" style="margin-top: -3px;">
        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.10302 0.473538C6.91735 0.298002 6.67153 0.200195 6.41602 0.200195C6.16051 0.200195 5.91469 0.298002 5.72902 0.473538L0.885016 5.05154C0.736698 5.19189 0.618598 5.36105 0.537952 5.54865C0.457307 5.73625 0.415814 5.93834 0.416016 6.14254V11.7125C0.416281 12.1102 0.574434 12.4915 0.85571 12.7726C1.13699 13.0536 1.51836 13.2115 1.91602 13.2115H3.41602C3.81384 13.2115 4.19537 13.0535 4.47668 12.7722C4.75798 12.4909 4.91602 12.1094 4.91602 11.7115V9.21154C4.91602 9.07893 4.9687 8.95175 5.06246 8.85798C5.15623 8.76422 5.28341 8.71154 5.41602 8.71154H7.41602C7.54862 8.71154 7.6758 8.76422 7.76957 8.85798C7.86334 8.95175 7.91602 9.07893 7.91602 9.21154V11.7115C7.91602 12.1094 8.07405 12.4909 8.35536 12.7722C8.63666 13.0535 9.01819 13.2115 9.41602 13.2115H10.916C11.3138 13.2115 11.6954 13.0535 11.9767 12.7722C12.258 12.4909 12.416 12.1094 12.416 11.7115V6.14154C12.416 5.93743 12.3742 5.73549 12.2934 5.54807C12.2126 5.36065 12.0944 5.19169 11.946 5.05154L7.10302 0.471538V0.473538Z"
            fill="#48a6a6" />
        </svg>
      </a>
      <span style="margin: -3px 12px 0 12px;">
        <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.227539 1.79558L1.27235 0.750765L6.22754 5.70595L1.27235 10.6611L0.227539 9.61632L4.13791 5.70595L0.227539 1.79558Z" fill="#9A9AB0" />
        </svg>
      </span>
      <span style="position: absolute; margin-top: 3px;">
        <breadcrumbs />
      </span> -->
      </div>
      <div class="col-md-8" style="padding:0px;">

        <div class="modal fade" id="emailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
          aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header" style="color: black">
                <h5 class="modal-title">Select to send password reset request</h5>
              </div>
              <div class="modal-body" style="height: 400px; max-height: 400px">
                <table class="
                    table   table-hover
                    text-center
                  " id="dataTable">
                  <thead>
                    <tr>
                      <th>Expand</th>
                      <th>Select</th>
                      <th>Company</th>
                      <th>Role</th>
                      <th>Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(info, key) in infos">
                      <tr style="background-color: #cae0f7;">
                        <td width="8%">
                          <button @click="toggle(key)" :class="{ opened: opened.includes(key) }"
                            style="border-radius: 3px; border: none">
                            <i class="fas fa-caret-right" aria-hidden="true" v-if="!opened.includes(key)"></i>
                            <i class="fas fa-caret-down" aria-hidden="true" v-else-if="opened.includes(key)"></i>
                          </button>
                        </td>
                        <td width="8%">
                          <input type="checkbox" @click="checkedMails(key, $event)" :value="key"
                            :id="key.split(' ').join('_')" :disabled="!opened.includes(key)" />
                        </td>
                        <td style="text-align: left">{{ key }}</td>
                        <td style="text-align: left"></td>
                        <td style="text-align: left"></td>
                        <th style="text-align: left"></th>
                      </tr>
                      <template v-if="opened.includes(key)" v-for="(data, Childkey) in info">
                        <tr :key="Childkey" style="color: #1977da; background-color: white">
                          <td></td>
                          <td>
                            <input type="checkbox" @click="
                                checkedChildMails(key, Childkey, data, $event),
                                  parentRemoveDisable(key)
                              " :value="data.email" :id="data.email" v-model="data.ischecked" style="margin-left: 30px" />
                          </td>
                          <td style="text-align: left">{{ data.user_name }}</td>
                          <td v-if="data.role_id === '0'">Admin</td>
                          <td v-else-if="data.role_id === '3'">Manager</td>
                          <td v-else-if="data.role_id === '6'">Driver</td>
                          <td v-else-if="data.role_id === '4'">
                            Shipping and Receiving
                          </td>
                          <td v-else-if="data.role_id === '9'">
                            Production Supervisor
                          </td>
                          <td v-else></td>
                          <th style="text-align: left">{{ data.email }}</th>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button type="button" @click="sendResetRequest" class="btn btn-primary">
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- hereeee -->
    <div class="row border_collapse_show">
    <div class="col-md-6" style="background:white;     border-top-left-radius: 10px; padding-top:12px; padding-bottom:12px; border: 1px solid #dfdfdf; border-right: none; border-bottom: none; ">
      <ul class="nav nav-pills " role="tablist">
          <li class="nav-item type1 ">
            <a class="nav-link demo  " v-bind:class="[ selectTab==0 ? 'active' : '']" href="javascript:void(0);"
              @click="demoStatus(0)">All</a>
          </li>
          <li class="nav-item type1 ">
            <a class="nav-link demo" v-bind:class="[ selectTab==1 ? 'active' : '']" href="javascript:void(0);"
              @click="demoStatus(1)">Active </a>
          </li>
          <li class="nav-item type1 ">
            <a class="nav-link demo" v-if="this.product == 1" v-bind:class="[ selectTab==2 ? 'active' : '']" href="javascript:void(0);"
              @click="demoStatus(2)">Trial </a>
          </li>
          <li class="nav-item type1 ">
            <a class="nav-link demo" v-if="this.product == 1" v-bind:class="[ selectTab==3 ? 'active' : '']" href="javascript:void(0);"
              @click="demoStatus(3)">Inactive </a>
          </li>
          <li class="nav-item type1 ">
            <a class="nav-link demo" v-if="this.product == 1" v-bind:class="[ selectTab==4 ? 'active' : '']" href="javascript:void(0);"
              @click="demoStatus(4)">Warning </a>
          </li>
          <!-- <li class="nav-item type1">
            <a class="nav-link demo" v-bind:class="[ selectTab==4 ? 'active' : '']" href="javascript:void(0);"
              @click="demoStatus(4)">Left </a>
          </li> -->
      </ul>
    </div>

    <div class="col-md-6" style="background:white;     border-top-right-radius: 10px; padding-top:18px; padding-bottom:8px; border: 1px solid #dfdfdf; border-left: none; border-bottom: none;">
      <button @click="createOrg" type="button" class="btn btn-sm float-right ml-2 add-lead btn btn-sm filter" style="
          color: white;
          padding: 5px 10px;
          cursor: pointer;
          border: 1px solid #48a6a6;
          padding: 7px 8px 3px 9px;"
      >
        <span class="fa fa-plus" style="font-size:18px;color:#48a6a6;"></span>
      </button>
      <button class="btn btn-sm filter" style="border: 1px solid #48a6a6; float: right; padding: 5px 7px 2px 8px;" type="button" data-toggle="collapse"
          data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"  v-on:click="ShowFilter"  v-if="$can('all_organization_filter')">
          <i class="fa fa-filter fa-lg py-1 icon" style="font-size:19px;color:#48a6a6;"></i>
          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 16 17" fill="none">
            <path
              d="M14.7358 0.484375H1.26203C1.03869 0.484375 0.824497 0.573097 0.666571 0.731024C0.508644 0.88895 0.419922 1.10314 0.419922 1.32649V3.50756C0.419922 3.94798 0.599292 4.38083 0.910873 4.69241L5.47259 9.25413V15.6424C5.47276 15.7859 5.50954 15.9269 5.57946 16.0522C5.64937 16.1775 5.75011 16.2829 5.87213 16.3583C5.99414 16.4338 6.13341 16.4769 6.27673 16.4835C6.42005 16.4901 6.56268 16.46 6.69113 16.3961L10.0596 14.7119C10.3451 14.5687 10.5253 14.2773 10.5253 13.9582V9.25413L15.087 4.69241C15.3986 4.38083 15.5779 3.94798 15.5779 3.50756V1.32649C15.5779 1.10314 15.4892 0.88895 15.3313 0.731024C15.1734 0.573097 14.9592 0.484375 14.7358 0.484375ZM9.08778 8.31012C9.00943 8.38819 8.94729 8.48098 8.90494 8.58316C8.8626 8.68534 8.84088 8.79489 8.84104 8.90549V13.4377L7.15682 14.2799V8.90549C7.15698 8.79489 7.13526 8.68534 7.09291 8.58316C7.05057 8.48098 6.98843 8.38819 6.91008 8.31012L2.10415 3.50756V2.1686H13.8946L13.8962 3.50166L9.08778 8.31012Z"
              fill="#48a6a6" />
          </svg> -->
      </button>
      <span id="excel" v-if="$can('all_organization_csv')">
        <download-excel class="btn btn-sm btn-outline-light color-default mr-2 ml-1 excel-download" style="
            color: #48a6a6 !important;
            border: 1px solid #48a6a6;
            padding: 7px 10px 4px 10px;
            cursor: pointer;
            float:right;
          " :name="excelFileName" :data="excelDownloadData" :fields="json_fields">
          <i class="fa fa-file-excel-o" style="font-size:19px"></i>
        </download-excel>
      </span>
      <div class="form-group"  v-if="$can('all_organization_bulk_reset_password') && this.product == 1"  style="float: right; margin-left: 10px">
          <input type="button" class="btn btn-default bulk_reset_password" style="color: #fff; background-color: #48a6a6; border-radius: 6px; padding: 7px 11px; font-size: 12px; font-weight: 600;"
            value="Bulk Reset Password" data-toggle="modal" @click="sendBulkEmail($event)" />
          <span class="checkmark"></span>
        </div>
      <div style="float: right; margin-bottom: 10px;" >
        <div class="float-left">
            <div class="has-search"  v-if="$can('all_organization_list')">
              <span class="fa fa-search form-control-feedback"></span>
              <input v-model="search" @keyup="organizationSearch" type="text" style="background-color: #edf2f5"
                class="form-control org-search" placeholder="Search Here..." />
            </div>
              <!-- <div class="has-search">
                <span class="fa fa-search form-control-feedback"></span>
                <input v-model="search" @keyup="organizationSearch" type="text" style="background-color: #edf2f5" class="form-control" placeholder="Search Here..." />
              </div> -->
        </div>
      </div>

    </div>


  </div>

<!-- hereeee -->
<div class="row" id="filters_row">
<div :class="show_filter"  class="row collapse mx-0 mt-0 " id="collapseExample" >
<!--<div class="row mt-2">-->
      <div class="col-md-4">
        <div class="col-md-12" v-if="this.product == 1">
          <div class="form-group">
            <label style="color:#48a6a6; font-weight: 600; font-size: 14px;">Update Organizations Status:</label>
            <select @change="organizationStatusSet($event)" v-model="user_status_to_set" class="form-control"
              style="padding: 5px 10px" placeholder="Select list">
              <option selected="selected" value="">Please Select</option>
              <option value="1">Active </option>
              <!-- <option value="2">Trial </option> -->
              <option value="3">Inactive </option>
              <option value="4">Warning </option>
            </select>
          </div>
        </div>
      </div>
<!--    </div>-->
  <div class="col-md-4">
    <div class="col-md-12" v-if="this.product == 1">
      <div class="form-group">
        <label style="color:#48a6a6; font-weight: 600; font-size: 14px;">Country:</label>
        <multiselect  :options="countries" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="country"
                      :multiple="true"  style="font-size:12px !important" placeholder="All Countries">
        </multiselect>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="col-md-12" v-if="this.product == 1">
      <div class="form-group">
        <label style="color:#48a6a6; font-weight: 600; font-size: 14px;">State:</label>
        <multiselect  :options="states" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="state"
                      :multiple="true" label="state" track-by="state" style="font-size:12px !important" placeholder="All States">
        </multiselect>
      </div>
    </div>
  </div>
</div>
</div>

<organization-table :organizations="organizations" :excelDownloadData="excelDownloadData" :totalPages="totalPages" :search="search"
  :totalRows="totalRows" :page="page" @setPage="setPage" :status="status" :skeletonLoader="skeletonLoader"></organization-table>
    <router-view :key="$route.fullPath"></router-view>

</div>



</template>

<script>
  import axios from 'axios';
  import helpers from '@/helpers.js';
  import OrganizationTable from './organization_table';
  import $ from 'jquery';
  import OrgForm from "../users/create_org_form.vue";
  import trialEndDate from "./trial_end_date.vue";
  import "vue-loading-overlay/dist/vue-loading.css";
  import Multiselect from "vue-multiselect";
  import {hasPermission} from "../../utils/permissions";
  export default {
    components: {
      Multiselect,
      OrganizationTable,
    },


    data: function () {
      return {
        country: [],
        state: [],
        countries: [], // Add countries as data property
        states: [], // Add states as data property
        selectedCouuntries: [],
        selectedStates: [],
        awaitingSearch: false,
        product: 0,
        show_filter: false,
        fullPage: true,
        search: "",
        user_status: "all",
        user_status_to_set: "",
        checkAll: true,
        infos: null,
        users_data: [],
        opened: [],
        information: [],
        selectedEmails: {},
        selected: [],
        allSelected: false,
        page: 0,
        selectTab: 0,
        status: 0,
        trial_date: '',
        excelDownloadData: [],
        excelFileName: "organization.xls",
        json_fields: {
          "Company name": "legal_name",
          "User name": "user_name",
          Email: "email",
          Phone: "phone",
          "Created At": "created_at_date",
          Status: "status",
        },
        skeletonLoader: true,
        org: this.get_empty_org_obj(),
        filters: ""
      }
    },

    computed: {
      selectedProduct: function () {
        return this.$store.getters["persist/selectedProduct"];
      },

      organizations: function () {
        return this.$store.getters['users/organizations'];
      },

      totalPages: function () {
        return this.$store.getters['users/totalPages'];
      },
      totalRows: function () {
        return this.$store.getters["users/totalRows"];
      },

      // Remove the states getter since we're using it as data property now
    },


    created: function () {
      this.product = localStorage.getItem('product');
      this.page = helpers.getPageQuery();
      this.show_filter = false;
      localStorage.setItem('filter_status', 0);
      this.getFilterData();
      this.getCountries();
    },
    watch: {
      page: function (val) {
        let filter = {
          "countries": this.selectedCouuntries,
          "states": this.selectedStates
        }
        this.product = localStorage.getItem('product');
        this.page = val
        this.filters = filter
        this.getOrganizationRecord();
      },
      organizations: function () {
        let org_array = JSON.parse(JSON.stringify(this.organizations));
        // console.log("org",org_array);
        $.each(org_array, function (key, value) {
          if (value.status == 1) {
            value.status = "Active";
          } else if (value.status == 2) {
            value.status = "Trial";
          } else if (value.status == 3) {
            value.status = "Inactive";
          } else if (value.status == 4) {
            value.status = "Warning";
          }
        });
        this.excelDownloadData = org_array;
      },
      selectedProduct: function () {
        this.product = localStorage.getItem('product');
        this.page = 1;
        this.search = '';
        this.getOrganizationRecord();
      },

      skeletonLoader: function (val) {
        return val;
      },


      country: function () {
        this.selectedCouuntries = this.country;
        let filter = {
          "countries": this.selectedCouuntries,
          "states": this.selectedStates
        }
        this.filters = JSON.stringify(filter);
        this.getOrganizationRecord();
      },

      state: function () {
        this.selectedStates = this.state.map((val) => val.state);
        let filter = {
          "countries": this.selectedCouuntries,
          "states": this.selectedStates
        }
        this.filters = JSON.stringify(filter);
        this.getOrganizationRecord();
      }


    },


    methods: {

      parentRemoveDisable(index) {
        let id = index.split(" ").join("_");
        var size = this.selectedEmails[index].filter(function (value) {
          return value !== undefined;
        }).length;

        if (this.infos[index].length == size) {
          $("#" + id).prop("checked", true);
          $("#" + id)
              .parent()
              .removeClass("parenCheckDisable");
        }
      },
      checkedMails(index, e) {
        let seletedOrg = this.infos[index];
        if (e.target.checked) {
          $.each(seletedOrg, function (k, val) {
            val["ischecked"] = true;
          });
          this.selectedEmails[index] = _.cloneDeep(seletedOrg);
        } else {
          $.each(seletedOrg, function (k, val) {
            val["ischecked"] = false;
          });
          delete this.selectedEmails[index];
        }

        let id = index.split(" ").join("_");
        $("#" + id)
            .parent()
            .removeClass("parenCheckDisable");
      },

      checkedChildMails(ParentIndex, ChildIndex, value, e) {
        let id = ParentIndex.split(" ").join("_");

        if (this.selectedEmails[ParentIndex]) {
          $("#" + id)
              .parent()
              .addClass("parenCheckDisable");

          if (e.target.checked) {
            this.selectedEmails[ParentIndex][ChildIndex] = value;
          } else {
            $("#" + id).prop("checked", false);
            delete this.selectedEmails[ParentIndex][ChildIndex];

            var size = this.selectedEmails[ParentIndex].filter(function (value) {
              return value !== undefined;
            }).length;
            if (size == 0) {
              $("#" + id)
                  .parent()
                  .removeClass("parenCheckDisable");
            }
          }
        } else {
          let new_data = [];
          for (var i = 0; i < this.infos[ParentIndex].length; i++) {
            if (i == ChildIndex) {
              new_data.push(value);
            } else {
              let data = undefined;
              new_data.push(data);
            }
          }
          this.selectedEmails[ParentIndex] = new_data;
          $("#" + id)
              .parent()
              .addClass("parenCheckDisable");
        }
      },
      toggle(id) {
        const index = this.opened.indexOf(id);
        if (index > -1) {
          this.opened.splice(index, 1);
        } else {
          this.opened.push(id);
        }
      },

      organizationSearch() {

        this.skeletonLoader = true;
        if (this.search.replace(/\s/g, "").length || this.search == '') {
            setTimeout(() => {
              this.getOrganizationRecord()
            }, 2000);
        }
      },
      changeAllChecboxes() {
        let self = this;
        self.checkAll = !self.checkAll;
        let children = this.$el.querySelectorAll(".user_row");
        for (var i = 0; i < children.length; i++) {
          children[i].checked = !self.checkAll;
        }
      },

      sendResetRequest() {
        this.skeletonLoader = true;
        let self = this;
        let user_data = this.selectedEmails;
        if ($.isEmptyObject(user_data)) {
          alert("Please check any Organizations first.");
          this.skeletonLoader = false;
          return;
        }

        if (!$.isEmptyObject(this.selectedEmails)) {
          $.each(this.selectedEmails, function (k, values) {
            $.each(values, function (k, val) {
              if (val !== undefined) {
                self.users_data.push(val);
              }
            });
          });
        }
        axios
            .post("admin/bulk-password-reset", {
              data: self.users_data,
            })
            .then(() => {
              self.users_data = [];
              this.skeletonLoader = false;
              this.$toast.success("Password Reset Request Send Successfully");
            })
            .catch(() => {
              this.skeletonLoader = false;
            });
      },

      sendBulkEmail() {
        $("#emailModal").modal();
      },
      ShowFilter() {
        this.show_filter == 'show' ? localStorage.setItem('show_filter', false) : localStorage.setItem('show_filter', 'show');


      },

      formateData(values) {
        let res = _.cloneDeep(values);
        let org_data = {};

        for (var i = 0; i < res.length; ++i) {
          var obj = res[i];
          obj["ischecked"] = false;

          if (org_data[obj.organization_name] === undefined)
            org_data[obj.organization_name] = [];

          if (obj.email != null) org_data[obj.organization_name].push(obj);
        }

        return org_data;
      },
      getUsers() {
        this.skeletonLoader = true;
        var limit = 0;
        axios.get("/admin/users?limit=" + limit).then((response) => {
          let res = response.data.data;
          let data = this.formateData(res);
          this.infos = data;
          // loader.hide();
          this.skeletonLoader = false;
        });
      },

      organizationStatusSet(event) {

        this.skeletonLoader = true;
        let children = this.$el.querySelectorAll(".user_row:checked");
        let status_selected = event.target.value;
        let org_ids = [];
        if (children.length > 0) {
          for (var i = 0; i < children.length; i++) {
            org_ids.push(children[i].dataset.id);
          }
          if (status_selected == 2) {
            this.trialenddate(status_selected, org_ids);
            this.skeletonLoader = false;
          } else {
            this.$store
                .dispatch("users/setOrganizationsStatus", [status_selected, org_ids])
                .then(() => {
                  this.skeletonLoader = false;
                });
          }

        } else {
          alert("Please check any Organizations first.");
          this.skeletonLoader = false;
        }


      },

      getOrganizationRecord() {
        this.skeletonLoader = true;
        this.$store.dispatch('users/getAllOraganizations', [this.page, this.search, this.status, this.filters])
            .then(() => {
              this.skeletonLoader = false;
            })
            .catch(() => {
              this.skeletonLoader = false;
            })
      },


      trialenddate(status_selected, org_ids) {
        this.$store.dispatch("modal/trialenddate", {
          action: "create",
          title: "Set Trial End Date",
          formData: {
            status_selected: status_selected,
            org_ids: org_ids,
          },
          component: trialEndDate,
        });
      },


      setPage(page) {
        this.page = page;
        this.getOrganizationRecord()
      },
      demoStatus(status) {
        this.status = status;
        this.search = "";
        localStorage.setItem('filter_status', this.status);
        this.page = 1;
        this.selectTab = this.status;
        this.getOrganizationRecord()
      },
      get_empty_org_obj() {
        return {
          country: "",
        };
      },

      createOrg() {
        this.$store.dispatch("modal/createOrg", {
          action: "create",
          title: "Create Organization",
          formData: {},
          component: OrgForm,
        });
      },

      getCountries() {
        if(hasPermission('all_organization_list')){
          const permission = {
            headers: {
              'X-Permission': 'all_organization_list'
            }
          };
          axios.get("admin/users/countries", permission).then((response) => {
            this.countries = response.data.countries;
          });
        }
      },

      getFilterData() {
        if(hasPermission('all_organization_list')){
          const permission = {
            headers: {
              'X-Permission': 'all_organization_list'
            }
          };
          axios.get("admin/users/organization/filter-data/state", permission).then((response) => {
            this.states = response.data;
          });
        }
      },
    },
    mounted() {
      this.getUsers();
    },
  }

</script>

<style scoped lang="scss">
.border_collapse_show{
  border-bottom: 1px solid #48a6a6;
  margin-right: 0px;margin-left: 0px;
  margin-top:0px;
}

.demo{
  margin: 5px;
  color: #615f5f;
  font-size: 16px;
  background: white;
}

  .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff;
    background-color: #48a6a6;
}
#filters_row{
  background: #f7f8f9;
    margin-left: 0px;
    margin-right: 0px;
    border-left: 1px solid #dfdfdf;
    border-right: 1px solid #dfdfdf;
}
.form-control.org-search{
  font-size: 0.85rem !important;
}
.excel-download:hover,.filter:hover{
    background: #48a6a6;
    .fa-file-excel-o,  .fa-filter, .fa-plus{
      color: white !important;
    }
  }
  .bulk_reset_password:hover{
    border: 1px solid #48a6a6 !important ;
    color: #48a6a6 !important ;
    background: white !important;
  }
</style>